module.exports = __webpack_public_path__ + "static/media/discoverIcon.869aa59e.jpeg";